export const REFRESH_TOKEN_KEY = 'simpl-refresh-token';
export const ACCESS_TOKEN_KEY = 'simpl-access-token';
